const LEAGUE_DIVISION = {
  NFL: "pro",
  "XFL/UFL": "pro",
  MLB: "pro",
  NBA: "pro",
  WNBA: "pro",
  NHL: "pro",
  MLS: "pro",
  MiLB: "semipro",
  AAPB: "semipro",
  "G-League": "semipro",
  ECHL: "semipro",
  USL: "semipro",
  USL2: "semipro",
  NCAA: "college",
  NAIA: "college",
};

export const DIVISIONS = [
  { key: "all", label: "ALL" },
  { key: "pro", label: "PRO" },
  { key: "semipro", label: "SEMI-PRO" },
  { key: "college", label: "COLLEGE" },
];

export const divisionOf = (league) => LEAGUE_DIVISION[league] || "pro";
